import { instance } from "api/apiBase";
import {
  Lockbox,
  GetLockboxesParams,
  GetLockboxesResponse,
  LockboxPayload,
  VerifyResult,
  GenerateLockboxCodePayload,
  AccessCode,
  AccessCodesResponse,
  LockboxActivityLogParams,
  LockboxActivityLogResponse
} from "./types";

const api = {
  getLockboxes: async (
    params: GetLockboxesParams = {}
  ): Promise<GetLockboxesResponse> => {
    return (await instance.get("/portal/v1/boom_crm/lockboxes", { params }))
      .data;
  },

  getLockbox: async (id: number): Promise<Lockbox> => {
    return (await instance.get(`/portal/v1/boom_crm/lockboxes/${id}`)).data;
  },

  createLockbox: async (data: LockboxPayload): Promise<Lockbox> => {
    return (await instance.post("/portal/v1/boom_crm/lockboxes", data)).data;
  },

  updateLockbox: async (
    id: number,
    data: Partial<LockboxPayload>
  ): Promise<Lockbox> => {
    return (await instance.patch(`/portal/v1/boom_crm/lockboxes/${id}`, data))
      .data;
  },

  deleteLockbox: async (id: number): Promise<void> => {
    await instance.delete(`/portal/v1/boom_crm/lockboxes/${id}`);
  },

  // Verifies the lockbox against its real vendor. Always resolves with a result envelope
  // (a failed verification is HTTP 200 with verified:false); only network/5xx/auth throw.
  // `automatic` marks the check that runs right after create, so the Activity log names Boom.
  verifyLockbox: async (
    id: number,
    { automatic = false }: { automatic?: boolean } = {}
  ): Promise<VerifyResult> => {
    return (
      await instance.post(`/portal/v1/boom_crm/lockboxes/${id}/verify`, {
        automatic
      })
    ).data;
  },

  getActivityLog: async (
    id: number,
    params: LockboxActivityLogParams = {}
  ): Promise<LockboxActivityLogResponse> => {
    return (
      await instance.get(`/portal/v1/boom_crm/lockboxes/${id}/activity_log`, {
        params
      })
    ).data;
  },

  bulkAssignAccount: async (
    lockbox_ids: number[],
    vendor_account_id: number
  ): Promise<void> => {
    await instance.post("/portal/v1/boom_crm/lockboxes/bulk_assign_account", {
      lockbox_ids,
      vendor_account_id
    });
  },

  generateCode: async (
    id: number,
    data: GenerateLockboxCodePayload = {}
  ): Promise<AccessCode> => {
    return (
      await instance.post(
        `/portal/v1/boom_crm/lockboxes/${id}/generate_code`,
        data
      )
    ).data;
  },

  listAccessCodes: async (id: number): Promise<AccessCodesResponse> => {
    return (
      await instance.get(`/portal/v1/boom_crm/lockboxes/${id}/access_codes`)
    ).data;
  },

  cancelAccessCode: async (id: number, accessCodeId: number): Promise<void> => {
    await instance.post(
      `/portal/v1/boom_crm/lockboxes/${id}/access_codes/${accessCodeId}/cancel`
    );
  }
};

export default api;
